(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beneficios"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarBeneficiosFlip(wrapper) {
    var tarjetas = wrapper.querySelectorAll('[data-bf-tarjeta]');

    var observador = new IntersectionObserver(function(entradas) {
      entradas.forEach(function(entrada, indice) {
        if (entrada.isIntersecting) {
          var tarjeta = entrada.target;
          var demora = Array.prototype.indexOf.call(tarjetas, tarjeta) * 80;
          setTimeout(function() {
            tarjeta.setAttribute('data-bf-visible', '');
          }, demora);
          observador.unobserve(tarjeta);
        }
      });
    }, { threshold: 0.15 });

    tarjetas.forEach(function(tarjeta) {
      observador.observe(tarjeta);

      tarjeta.addEventListener('click', function() {
        if (!window.matchMedia('(min-width: 991px)').matches) {
          var activa = tarjeta.hasAttribute('data-bf-activa');
          tarjetas.forEach(function(t) {
            t.removeAttribute('data-bf-activa');
          });
          if (!activa) {
            tarjeta.setAttribute('data-bf-activa', '');
          }
        }
      });

      tarjeta.addEventListener('keydown', function(evento) {
        if (evento.key === 'Enter' || evento.key === ' ') {
          evento.preventDefault();
          tarjeta.click();
        }
      });
    });
  }

  function inicializarTodos() {
    document.querySelectorAll('.beneficios-flip__wrapper').forEach(function(wrapper) {
      iniciarBeneficiosFlip(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodos);
  } else {
    inicializarTodos();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var wrapper = event.target.querySelector('.beneficios-flip__wrapper');
    if (wrapper) iniciarBeneficiosFlip(wrapper);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categoriasdestacadas"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarCategoriasDestacadas(wrapper) {
    var paneles = wrapper.querySelectorAll('[data-cd-panel]');
    var esDesktop = window.matchMedia('(min-width: 991px)').matches;

    function activar(panel) {
      paneles.forEach(function(p) {
        p.removeAttribute('data-cd-activo');
      });
      panel.setAttribute('data-cd-activo', '');
    }

    paneles.forEach(function(panel) {
      panel.addEventListener('mouseenter', function() {
        if (window.matchMedia('(min-width: 991px)').matches) {
          activar(panel);
        }
      });

      panel.addEventListener('click', function(evento) {
        if (!window.matchMedia('(min-width: 991px)').matches) {
          if (!panel.hasAttribute('data-cd-activo')) {
            evento.preventDefault();
            activar(panel);
          }
        }
      });
    });
  }

  function inicializarTodos() {
    document.querySelectorAll('.categorias-destacadas__wrapper').forEach(function(wrapper) {
      iniciarCategoriasDestacadas(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodos);
  } else {
    inicializarTodos();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var wrapper = event.target.querySelector('.categorias-destacadas__wrapper');
    if (wrapper) iniciarCategoriasDestacadas(wrapper);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqnuevo"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarFaqInnovador(wrapper) {
    var items = wrapper.querySelectorAll('[data-faqi-item]');
    var buscador = wrapper.querySelector('[data-faqi-buscador]');
    var sinResultados = wrapper.querySelector('[data-faqi-sin-resultados]');

    items.forEach(function(item) {
      var boton = item.querySelector('[data-faqi-boton]');
      var respuestaWrap = item.querySelector('[data-faqi-respuesta-wrap]');
      var respuesta = item.querySelector('[data-faqi-respuesta]');

      boton.addEventListener('click', function() {
        var abierto = item.hasAttribute('data-faqi-abierto');

        items.forEach(function(otro) {
          if (otro !== item) {
            otro.removeAttribute('data-faqi-abierto');
            otro.querySelector('[data-faqi-boton]').setAttribute('aria-expanded', 'false');
            otro.querySelector('[data-faqi-respuesta-wrap]').style.maxHeight = null;
          }
        });

        if (abierto) {
          item.removeAttribute('data-faqi-abierto');
          boton.setAttribute('aria-expanded', 'false');
          respuestaWrap.style.maxHeight = null;
        } else {
          item.setAttribute('data-faqi-abierto', '');
          boton.setAttribute('aria-expanded', 'true');
          respuestaWrap.style.maxHeight = respuesta.scrollHeight + 20 + 'px';
        }
      });
    });

    if (buscador) {
      buscador.addEventListener('input', function() {
        var valor = buscador.value.trim().toLowerCase();
        var visibles = 0;

        items.forEach(function(item) {
          var texto = item.getAttribute('data-faqi-texto') || '';
          if (valor === '' || texto.indexOf(valor) !== -1) {
            item.removeAttribute('data-faqi-oculto');
            visibles++;
          } else {
            item.setAttribute('data-faqi-oculto', '');
            item.removeAttribute('data-faqi-abierto');
            var wrap = item.querySelector('[data-faqi-respuesta-wrap]');
            if (wrap) wrap.style.maxHeight = null;
          }
        });

        if (sinResultados) {
          if (visibles === 0) {
            sinResultados.setAttribute('data-faqi-visible', '');
          } else {
            sinResultados.removeAttribute('data-faqi-visible');
          }
        }
      });
    }
  }

  function inicializarTodos() {
    document.querySelectorAll('.faq-innovador__wrapper').forEach(function(wrapper) {
      iniciarFaqInnovador(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodos);
  } else {
    inicializarTodos();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var wrapper = event.target.querySelector('.faq-innovador__wrapper');
    if (wrapper) iniciarFaqInnovador(wrapper);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footeer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hg-footer__fondo').forEach(function (vid) {
  vid.muted = true;
  var tryPlay = function () {
    var p = vid.play();
    if (p && p.catch) p.catch(function () {});
  };
  vid.addEventListener('canplay', tryPlay);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tryPlay();
  });
  tryPlay();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["letrasfluidas"] && !Shopify.designMode) return;
  try {
    
(function() {
  function iniciarTextoScrollReveal(contenedor) {
    var palabras = contenedor.querySelectorAll('[data-tsr-palabra]');
    var total = palabras.length;
    var ticking = false;

    function actualizar() {
      var rect = contenedor.getBoundingClientRect();
      var alturaTotal = rect.height - window.innerHeight;
      if (alturaTotal <= 0) alturaTotal = 1;
      var progreso = (0 - rect.top) / alturaTotal;
      if (progreso < 0) progreso = 0;
      if (progreso > 1) progreso = 1;

      var palabrasActivas = Math.round(progreso * total);

      for (var i = 0; i < total; i++) {
        if (i < palabrasActivas) {
          palabras[i].classList.add('tsr-activa');
        } else {
          palabras[i].classList.remove('tsr-activa');
        }
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(actualizar);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    actualizar();
  }

  function inicializarTodos() {
    document.querySelectorAll('.texto-scroll-reveal__wrapper').forEach(function(wrapper) {
      iniciarTextoScrollReveal(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodos);
  } else {
    inicializarTodos();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var wrapper = event.target.querySelector('.texto-scroll-reveal__wrapper');
    if (wrapper) iniciarTextoScrollReveal(wrapper);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mas-vendidos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var desplazamientoGuardado = 0;
  var bloqueos = 0;

  function bloquearPagina() {
    bloqueos += 1;
    if (bloqueos > 1) return;
    desplazamientoGuardado = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-desplazamientoGuardado) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function liberarPagina() {
    bloqueos = Math.max(0, bloqueos - 1);
    if (bloqueos > 0) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, desplazamientoGuardado);
  }

  function formatearDinero(centavos, formato) {
    var valor = (centavos || 0) / 100;
    function coma(numero, decimales, separadorMiles, separadorDecimal) {
      var partes = numero.toFixed(decimales).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadorMiles);
      return partes.length > 1 ? partes[0] + separadorDecimal + partes[1] : partes[0];
    }
    var patron = /\{\{\s*(\w+)\s*\}\}/;
    var coincidencia = (formato || '${{amount}}').match(patron);
    var tipo = coincidencia ? coincidencia[1] : 'amount';
    var salida;
    if (tipo === 'amount_no_decimals') salida = coma(valor, 0, ',', '.');
    else if (tipo === 'amount_with_comma_separator') salida = coma(valor, 2, '.', ',');
    else if (tipo === 'amount_no_decimals_with_comma_separator') salida = coma(valor, 0, '.', ',');
    else if (tipo === 'amount_with_apostrophe_separator') salida = coma(valor, 2, "'", '.');
    else salida = coma(valor, 2, ',', '.');
    return (formato || '${{amount}}').replace(patron, salida);
  }

  function iniciar(seccion) {
    if (!seccion || seccion.dataset.mvIniciado === '1') return;
    seccion.dataset.mvIniciado = '1';

    var nodoConfig = seccion.querySelector('[data-mas-vendidos-config]');
    var cfg = {};
    try { cfg = JSON.parse(nodoConfig.textContent); } catch (e) { cfg = {}; }

    var idioma = cfg.idioma;
    if (!idioma || idioma === 'auto') {
      var lt = (cfg.localeTienda || '').toLowerCase();
      var nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
      if (lt.indexOf('en') === 0) idioma = 'en';
      else if (lt.indexOf('es') === 0) idioma = 'es';
      else if (nav.indexOf('en') === 0) idioma = 'en';
      else idioma = 'es';
    }
    var t = (cfg.textos && cfg.textos[idioma]) || (cfg.textos && cfg.textos.es) || {};
    var formato = cfg.formatoDinero || '${{amount}}';
    var identificador = seccion.getAttribute('data-seccion');
    var estilos = seccion.getAttribute('style') || '';

    seccion.querySelectorAll('[data-mv-texto]').forEach(function (nodo) {
      var valor = nodo.getAttribute('data-' + idioma);
      if (valor) nodo.textContent = valor;
    });

    var modal = seccion.querySelector('[data-mv-modal]');
    var popupCarrito = seccion.querySelector('[data-mv-carrito]');

    document.querySelectorAll('body > [data-mv-portal="' + identificador + '"]').forEach(function (viejo) {
      viejo.parentNode.removeChild(viejo);
    });

    [modal, popupCarrito].forEach(function (nodo) {
      if (!nodo) return;
      nodo.setAttribute('style', estilos);
      if (cfg.brillo) nodo.classList.add('mas-vendidos-brillo');
      if (!cfg.cerrarFondo) {
        var velo = nodo.querySelector('[data-mv-fondo]');
        if (velo) {
          velo.removeAttribute('data-mv-cerrar');
          velo.removeAttribute('data-mv-cerrar-carrito');
        }
      }
      document.body.appendChild(nodo);
    });

    if (cfg.brillo) seccion.classList.add('mas-vendidos-brillo');

    function reproducir(nodo) {
      nodo.classList.remove('mas-vendidos-animar');
      if (!cfg.animacion) return;
      void nodo.offsetWidth;
      nodo.classList.add('mas-vendidos-animar');
    }

    var pista = seccion.querySelector('[data-mv-pista]');
    var viewport = seccion.querySelector('[data-mv-viewport]');
    var originales = Array.prototype.slice.call(pista ? pista.children : []);
    var total = originales.length;
    var paso = 0;
    var reloj = null;
    var enPausa = false;
    var sentido = cfg.direccion === 'retroceder' ? -1 : 1;

    function anchoPaso() {
      var estilo = window.getComputedStyle(pista);
      var gap = parseFloat(estilo.columnGap || estilo.gap || '0') || 0;
      var primera = pista.children[0];
      return (primera ? primera.getBoundingClientRect().width : 0) + gap;
    }

    function aplicar(animar, extra) {
      pista.classList.toggle('mas-vendidos-pista--sin-transicion', !animar);
      pista.style.transform = 'translate3d(' + (-(paso * anchoPaso()) + (extra || 0)) + 'px,0,0)';
    }

    function mover(direccion) {
      paso += direccion;
      aplicar(true);
    }

    function arrancar() {
      if (!cfg.autoplay || total < 2) return;
      detener();
      reloj = window.setInterval(function () {
        if (!enPausa) mover(sentido);
      }, cfg.intervalo || 5000);
    }

    function detener() {
      if (reloj) window.clearInterval(reloj);
      reloj = null;
    }

    if (pista && total > 0) {
      originales.forEach(function (tarjeta) {
        var previo = tarjeta.cloneNode(true);
        previo.setAttribute('data-mv-clon', '1');
        previo.setAttribute('aria-hidden', 'true');
        pista.insertBefore(previo, pista.children[0]);
      });
      originales.forEach(function (tarjeta) {
        var posterior = tarjeta.cloneNode(true);
        posterior.setAttribute('data-mv-clon', '1');
        posterior.setAttribute('aria-hidden', 'true');
        pista.appendChild(posterior);
      });

      paso = total;
      aplicar(false);

      pista.addEventListener('transitionend', function (evento) {
        if (evento.target !== pista || evento.propertyName !== 'transform') return;
        if (paso >= total * 2) { paso -= total; aplicar(false); }
        if (paso < total) { paso += total; aplicar(false); }
      });

      window.addEventListener('resize', function () { aplicar(false); });
      window.addEventListener('load', function () { aplicar(false); });

      if (cfg.pausaHover && viewport) {
        viewport.addEventListener('mouseenter', function () { enPausa = true; });
        viewport.addEventListener('mouseleave', function () { enPausa = false; });
      }

      if (cfg.deslizar && viewport) {
        var inicioX = 0;
        var inicioY = 0;
        var delta = 0;
        var arrastrando = false;
        var horizontal = null;

        function comenzar(x, y) {
          inicioX = x;
          inicioY = y;
          delta = 0;
          horizontal = null;
          arrastrando = true;
          enPausa = true;
          detener();
        }

        function seguir(x, y, evento) {
          if (!arrastrando) return;
          var dx = x - inicioX;
          var dy = y - inicioY;
          if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
            horizontal = Math.abs(dx) > Math.abs(dy);
            if (horizontal) viewport.classList.add('mas-vendidos-viewport--arrastrando');
          }
          if (!horizontal) return;
          if (evento && evento.cancelable) evento.preventDefault();
          delta = dx;
          aplicar(false, delta);
        }

        function terminar() {
          if (!arrastrando) return;
          arrastrando = false;
          viewport.classList.remove('mas-vendidos-viewport--arrastrando');
          var umbral = Math.max(40, anchoPaso() * 0.18);
          if (horizontal && Math.abs(delta) > umbral) {
            paso += delta < 0 ? 1 : -1;
          }
          aplicar(true);
          delta = 0;
          horizontal = null;
          enPausa = false;
          arrancar();
        }

        viewport.addEventListener('touchstart', function (e) {
          comenzar(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });
        viewport.addEventListener('touchmove', function (e) {
          seguir(e.touches[0].clientX, e.touches[0].clientY, e);
        }, { passive: false });
        viewport.addEventListener('touchend', terminar);
        viewport.addEventListener('touchcancel', terminar);

        viewport.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          comenzar(e.clientX, e.clientY);
        });
        window.addEventListener('mousemove', function (e) {
          if (!arrastrando) return;
          seguir(e.clientX, e.clientY, e);
        });
        window.addEventListener('mouseup', terminar);

        viewport.addEventListener('click', function (e) {
          if (Math.abs(delta) > 6) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }

      arrancar();
    }

    var modalImg = modal.querySelector('[data-mv-modal-img]');
    var modalNombre = modal.querySelector('[data-mv-modal-nombre]');
    var modalPrecio = modal.querySelector('[data-mv-modal-precio]');
    var contOpciones = modal.querySelector('[data-mv-opciones]');
    var btnAgregar = modal.querySelector('[data-mv-agregar]');
    var textoAgregar = modal.querySelector('[data-mv-agregar-texto]');
    var nodoError = modal.querySelector('[data-mv-error]');
    var productoActual = null;
    var varianteActual = null;

    function mostrarError(mensaje) {
      if (!nodoError) return;
      if (!mensaje) {
        nodoError.hidden = true;
        nodoError.textContent = '';
        return;
      }
      nodoError.hidden = false;
      nodoError.textContent = mensaje;
    }

    function leerDatos(tarjeta) {
      var nodo = tarjeta.querySelector('[data-mv-datos]');
      if (!nodo) return null;
      try { return JSON.parse(nodo.textContent); } catch (e) { return null; }
    }

    function catalogo() {
      return Array.prototype.slice.call(pista ? pista.children : [])
        .filter(function (n) { return !n.hasAttribute('data-mv-clon'); })
        .map(leerDatos)
        .filter(Boolean);
    }

    function variantesDisponibles(producto, seleccion) {
      return producto.variants.filter(function (v) {
        return seleccion.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function pintarVariante() {
      if (!productoActual) return;
      if (varianteActual) {
        modalPrecio.textContent = formatearDinero(varianteActual.price, formato);
        if (varianteActual.featured_image && varianteActual.featured_image.src) {
          modalImg.src = varianteActual.featured_image.src;
        }
        btnAgregar.disabled = !varianteActual.available;
        textoAgregar.textContent = varianteActual.available ? (t.agregar || '') : (t.agotado || '');
      } else {
        btnAgregar.disabled = true;
        textoAgregar.textContent = t.agotado || '';
      }
    }
       var etiquetasProducto = {
      'hismile': { opcion: 'Tamaño', valores: { 'Default Title': '30 ml' } },
      'pdrn-pink': { opcion: 'Tamaño', valores: { 'Default Title': '40 ml' } }
    };

    function etiquetaOpcion(producto, nombre) {
      var mapa = etiquetasProducto[producto.handle];
      return mapa && mapa.opcion ? mapa.opcion : nombre;
    }

    function etiquetaValor(producto, valor) {
      var mapa = etiquetasProducto[producto.handle];
      return mapa && mapa.valores && mapa.valores[valor] ? mapa.valores[valor] : valor;
    }
    function construirOpciones(producto) {
      contOpciones.innerHTML = '';
      var seleccion = producto.variants[0] ? producto.variants[0].options.slice() : [];
      (producto.options || []).forEach(function (opcion, indice) {
        var nombreOpcion = typeof opcion === 'string' ? opcion : opcion.name;
        var valores = [];
        producto.variants.forEach(function (v) {
          if (valores.indexOf(v.options[indice]) === -1) valores.push(v.options[indice]);
        });
        var envoltorio = document.createElement('div');
        var etiqueta = document.createElement('label');
        etiqueta.className = 'mas-vendidos-opcion-label';
        etiqueta.textContent = etiquetaOpcion(producto, nombreOpcion);
        var select = document.createElement('select');
        select.className = 'mas-vendidos-opcion-select';
        valores.forEach(function (valor) {
          var op = document.createElement('option');
          op.value = valor;
          op.textContent = etiquetaValor(producto, valor);
          if (valor === seleccion[indice]) op.selected = true;
          select.appendChild(op);
        });
        select.addEventListener('change', function () {
          seleccion[indice] = select.value;
          var candidatas = variantesDisponibles(producto, seleccion);
          varianteActual = candidatas[0] || null;
          if (varianteActual) seleccion = varianteActual.options.slice();
          pintarVariante();
        });
        envoltorio.appendChild(etiqueta);
        envoltorio.appendChild(select);
        contOpciones.appendChild(envoltorio);
      });
      varianteActual = producto.variants.filter(function (v) { return v.available; })[0] || producto.variants[0] || null;
      if (varianteActual) {
        (producto.options || []).forEach(function (opcion, indice) {
          var select = contOpciones.querySelectorAll('select')[indice];
          if (select) select.value = varianteActual.options[indice];
        });
      }
    }

    function abrirModal(producto) {
      productoActual = producto;
      mostrarError('');
      modalNombre.textContent = producto.title;
      var imagen = producto.featured_image || (producto.images && producto.images[0]) || '';
      modalImg.src = typeof imagen === 'string' ? imagen : (imagen.src || '');
      modalImg.alt = producto.title;
      construirOpciones(producto);
      pintarVariante();
      cerrarCarrito();
      modal.hidden = false;
      reproducir(modal);
      bloquearPagina();
    }

    function cerrarModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      modal.classList.remove('mas-vendidos-animar');
      liberarPagina();
    }

    seccion.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-mv-abrir]');
      if (!boton) return;
      evento.preventDefault();
      evento.stopPropagation();
      var tarjeta = boton.closest('[data-mv-tarjeta]');
      var datos = leerDatos(tarjeta);
      if (datos) abrirModal(datos);
    });

    modal.querySelectorAll('[data-mv-cerrar]').forEach(function (nodo) {
      nodo.addEventListener('click', cerrarModal);
    });

    var contLineas = popupCarrito.querySelector('[data-mv-lineas]');
    var contReco = popupCarrito.querySelector('[data-mv-reco]');
    var nodoNota = popupCarrito.querySelector('[data-mv-nota]');

    function textosCarrito() {
      var titulo = popupCarrito.querySelector('[data-mv-carrito-titulo]');
      if (titulo) titulo.textContent = t.carrito || '';
      var recoTitulo = popupCarrito.querySelector('[data-mv-reco-titulo]');
      if (recoTitulo) recoTitulo.textContent = t.recomendados || '';
      var subEtiqueta = popupCarrito.querySelector('[data-mv-subtotal-etiqueta]');
      if (subEtiqueta) subEtiqueta.textContent = t.subtotal || '';
      var impuestos = popupCarrito.querySelector('[data-mv-impuestos]');
      if (impuestos) impuestos.textContent = t.impuestos || '';
      var instr = popupCarrito.querySelector('[data-mv-instrucciones-etiqueta]');
      if (instr) instr.textContent = t.instrucciones || '';
      var ver = popupCarrito.querySelector('[data-mv-ver-carrito] span');
      if (ver) ver.textContent = t.verCarrito || '';
      var check = popupCarrito.querySelector('[data-mv-checkout] span');
      if (check) check.textContent = t.checkout || '';
    }

    function lineaDeProducto(carrito, producto) {
      var ids = producto.variants.map(function (v) { return v.id; });
      var encontrada = null;
      (carrito.items || []).forEach(function (linea) {
        if (!encontrada && ids.indexOf(linea.variant_id) !== -1) encontrada = linea;
      });
      return encontrada;
    }

    function pintarReco(carrito) {
      if (!contReco) return;
      contReco.innerHTML = '';
      catalogo().slice(0, cfg.cantidadReco || 4).forEach(function (datos) {
        var item = document.createElement('div');
        item.className = 'mas-vendidos-reco-item';
        var foto = document.createElement('div');
        foto.className = 'mas-vendidos-reco-foto';
        var img = document.createElement('img');
        var imagen = datos.featured_image || (datos.images && datos.images[0]) || '';
        img.src = typeof imagen === 'string' ? imagen : (imagen.src || '');
        img.alt = datos.title;
        foto.appendChild(img);
        var info = document.createElement('div');
        info.className = 'mas-vendidos-reco-datos';
        var nombre = document.createElement('p');
        nombre.className = 'mas-vendidos-reco-nombre';
        nombre.textContent = datos.title;
        var precio = document.createElement('p');
        precio.className = 'mas-vendidos-reco-precio';
        precio.textContent = (datos.price_varies ? (t.desde || '') + ' ' : '') + formatearDinero(datos.price, formato);
        if (datos.compare_at_price && datos.compare_at_price > datos.price) {
          var tachado = document.createElement('s');
          tachado.textContent = formatearDinero(datos.compare_at_price, formato);
          precio.appendChild(tachado);
        }
        info.appendChild(nombre);
        info.appendChild(precio);
        item.appendChild(foto);
        item.appendChild(info);

        var linea = lineaDeProducto(carrito, datos);
        if (linea) {
          var control = document.createElement('div');
          control.className = 'mas-vendidos-cantidad';
          var menos = document.createElement('button');
          menos.type = 'button';
          menos.textContent = '−';
          var valor = document.createElement('span');
          valor.textContent = linea.quantity;
          var mas = document.createElement('button');
          mas.type = 'button';
          mas.textContent = '+';
          menos.addEventListener('click', function () { cambiar(linea.key, linea.quantity - 1); });
          mas.addEventListener('click', function () { cambiar(linea.key, linea.quantity + 1); });
          control.appendChild(menos);
          control.appendChild(valor);
          control.appendChild(mas);
          item.appendChild(control);
        } else {
          var boton = document.createElement('button');
          boton.type = 'button';
          boton.className = 'mas-vendidos-reco-boton';
          boton.textContent = t.add || '';
          boton.addEventListener('click', function () {
            var disponibles = datos.variants.filter(function (v) { return v.available; });
            if (datos.variants.length > 1) {
              abrirModal(datos);
            } else if (disponibles[0]) {
              agregar(disponibles[0].id, 1);
            }
          });
          item.appendChild(boton);
        }
        contReco.appendChild(item);
      });
    }

    function pintarCarrito(carrito) {
      textosCarrito();
      contLineas.innerHTML = '';
      if (!carrito.items || !carrito.items.length) {
        var vacio = document.createElement('p');
        vacio.className = 'mas-vendidos-vacio';
        vacio.textContent = t.vacio || '';
        contLineas.appendChild(vacio);
      }
      (carrito.items || []).forEach(function (linea) {
        var fila = document.createElement('div');
        fila.className = 'mas-vendidos-linea';
        var foto = document.createElement('div');
        foto.className = 'mas-vendidos-linea-foto';
        var img = document.createElement('img');
        img.src = linea.image || '';
        img.alt = linea.product_title;
        foto.appendChild(img);
        var datos = document.createElement('div');
        datos.className = 'mas-vendidos-linea-datos';
        var nombre = document.createElement('p');
        nombre.className = 'mas-vendidos-linea-nombre';
        nombre.textContent = linea.product_title;
        datos.appendChild(nombre);
        if (linea.variant_title) {
          var variante = document.createElement('p');
          variante.className = 'mas-vendidos-linea-variante';
          variante.textContent = linea.variant_title;
          datos.appendChild(variante);
        }
        var precio = document.createElement('p');
        precio.className = 'mas-vendidos-linea-precio';
        precio.textContent = formatearDinero(linea.final_line_price, formato);
        datos.appendChild(precio);
        var control = document.createElement('div');
        control.className = 'mas-vendidos-linea-control';
        var cantidad = document.createElement('div');
        cantidad.className = 'mas-vendidos-cantidad';
        var menos = document.createElement('button');
        menos.type = 'button';
        menos.textContent = '−';
        var valor = document.createElement('span');
        valor.textContent = linea.quantity;
        var mas = document.createElement('button');
        mas.type = 'button';
        mas.textContent = '+';
        menos.addEventListener('click', function () { cambiar(linea.key, linea.quantity - 1); });
        mas.addEventListener('click', function () { cambiar(linea.key, linea.quantity + 1); });
        cantidad.appendChild(menos);
        cantidad.appendChild(valor);
        cantidad.appendChild(mas);
        var quitar = document.createElement('button');
        quitar.type = 'button';
        quitar.className = 'mas-vendidos-quitar';
        quitar.textContent = t.quitar || '';
        quitar.addEventListener('click', function () { cambiar(linea.key, 0); });
        control.appendChild(cantidad);
        control.appendChild(quitar);
        fila.appendChild(foto);
        fila.appendChild(datos);
        fila.appendChild(control);
        contLineas.appendChild(fila);
      });
      var subtotal = popupCarrito.querySelector('[data-mv-subtotal-valor]');
      if (subtotal) subtotal.textContent = formatearDinero(carrito.total_price, formato) + ' ' + (carrito.currency || '');
      if (nodoNota && document.activeElement !== nodoNota) nodoNota.value = carrito.note || '';
      pintarReco(carrito);
    }

    function abrirCarrito() {
      if (!popupCarrito.hidden) return;
      popupCarrito.hidden = false;
      reproducir(popupCarrito);
      bloquearPagina();
    }

    function cerrarCarrito() {
      if (popupCarrito.hidden) return;
      popupCarrito.hidden = true;
      popupCarrito.classList.remove('mas-vendidos-animar');
      liberarPagina();
    }

    function pedirCarrito() {
      return fetch('/cart.js?mv=' + Date.now(), {
        method: 'GET',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
      }).then(function (r) { return r.json(); });
    }

    function refrescar(abrir) {
      return pedirCarrito().then(function (carrito) {
        pintarCarrito(carrito);
        if (abrir) abrirCarrito();
        document.dispatchEvent(new CustomEvent('mas-vendidos:carrito', { detail: carrito }));
        return carrito;
      });
    }

    function agregar(id, cantidad) {
      if (btnAgregar) btnAgregar.disabled = true;
      return fetch('/cart/add.js', {
        method: 'POST',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: cantidad || 1 }] })
      }).then(function (respuesta) {
        return respuesta.json().then(function (cuerpo) {
          if (!respuesta.ok) throw new Error(cuerpo.description || cuerpo.message || (t.error || ''));
          return cuerpo;
        });
      }).then(function () {
        if (btnAgregar) btnAgregar.disabled = false;
        cerrarModal();
        return refrescar(true);
      }).catch(function (error) {
        if (btnAgregar) btnAgregar.disabled = false;
        mostrarError(error && error.message ? error.message : (t.error || ''));
      });
    }

    function cambiar(clave, cantidad) {
      return fetch('/cart/change.js', {
        method: 'POST',
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: clave, quantity: Math.max(0, cantidad) })
      }).then(function (r) { return r.json(); })
        .then(function (carrito) {
          pintarCarrito(carrito);
          document.dispatchEvent(new CustomEvent('mas-vendidos:carrito', { detail: carrito }));
        });
    }

    if (btnAgregar) {
      btnAgregar.addEventListener('click', function () {
        if (varianteActual && varianteActual.available) agregar(varianteActual.id, 1);
      });
    }

    popupCarrito.querySelectorAll('[data-mv-cerrar-carrito]').forEach(function (nodo) {
      nodo.addEventListener('click', cerrarCarrito);
    });

    if (nodoNota) {
      var temporizador = null;
      nodoNota.addEventListener('input', function () {
        clearTimeout(temporizador);
        temporizador = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: nodoNota.value })
          });
        }, 500);
      });
    }

    document.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape') { cerrarModal(); cerrarCarrito(); }
    });

    var verCarrito = popupCarrito.querySelector('[data-mv-ver-carrito]');
    if (verCarrito && cfg.urlCarrito) verCarrito.setAttribute('href', cfg.urlCarrito);
    textosCarrito();
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-mas-vendidos]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var nodo = evento.target.querySelector('[data-mas-vendidos]');
    if (nodo) iniciar(nodo);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recorrido-lateral"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (!seccion || seccion.dataset.recIniciado === '1') return;
    seccion.dataset.recIniciado = '1';

    var cfg = {};
    try { cfg = JSON.parse(seccion.querySelector('[data-recorrido-config]').textContent); } catch (e) { cfg = {}; }

    var marco = seccion.querySelector('[data-rec-marco]');
    var fijo = seccion.querySelector('[data-rec-fijo]');
    var pista = seccion.querySelector('[data-rec-pista]');
    var barra = seccion.querySelector('[data-rec-barra]');
    if (!marco || !fijo || !pista) return;

    var distancia = 0;
    var altoFijo = 0;
    var actual = 0;
    var objetivo = 0;
    var visible = false;
    var apilado = false;
    var suave = cfg.suavizado || 1;
    var estado = '';

    function fijarVh() {
      seccion.style.setProperty('--rec-vh', (window.innerHeight * 0.01) + 'px');
    }
    fijarVh();

    function esApilado() {
      return cfg.apilarMobile && window.innerWidth < 750;
    }

    function medir() {
      apilado = esApilado();
      if (apilado) {
        marco.style.height = '';
        fijo.style.width = '';
        fijo.style.left = '';
        pista.style.transform = '';
        seccion.classList.remove('recorrido--anclado', 'recorrido--final');
        estado = '';
        distancia = 0;
        return;
      }
      fijarVh();
      altoFijo = window.innerHeight * ((cfg.alto || 100) / 100);
      var ancho = marco.getBoundingClientRect().width;
      distancia = Math.max(0, pista.scrollWidth - ancho);
      marco.style.height = (altoFijo + distancia * (cfg.velocidad || 1)) + 'px';
      colocar();
      objetivo = calcular();
      actual = objetivo;
      pintar();
    }

    function colocar() {
      var rect = marco.getBoundingClientRect();
      var recorrible = marco.offsetHeight - altoFijo;
      var nuevo;
      if (rect.top > 0 || recorrible <= 0) nuevo = 'inicio';
      else if (-rect.top >= recorrible) nuevo = 'final';
      else nuevo = 'anclado';

      if (nuevo !== estado) {
        estado = nuevo;
        seccion.classList.toggle('recorrido--anclado', nuevo === 'anclado');
        seccion.classList.toggle('recorrido--final', nuevo === 'final');
      }

      if (nuevo === 'anclado') {
        fijo.style.left = rect.left + 'px';
        fijo.style.width = rect.width + 'px';
      } else {
        fijo.style.left = '';
        fijo.style.width = '';
      }
    }

    function calcular() {
      var recorrible = marco.offsetHeight - altoFijo;
      if (recorrible <= 0) return 0;
      var avance = (-marco.getBoundingClientRect().top) / recorrible;
      if (avance < 0) avance = 0;
      if (avance > 1) avance = 1;
      return avance * distancia;
    }

    function pintar() {
      pista.style.transform = 'translate3d(' + (-actual) + 'px,0,0)';
      if (barra) barra.style.transform = 'scaleX(' + (distancia ? actual / distancia : 0) + ')';
    }

    function ciclo() {
      if (visible && !apilado) {
        colocar();
        objetivo = calcular();
        if (suave >= 1) {
          actual = objetivo;
        } else {
          actual += (objetivo - actual) * suave;
          if (Math.abs(objetivo - actual) < 0.4) actual = objetivo;
        }
        pintar();
      }
      window.requestAnimationFrame(ciclo);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
      }, { rootMargin: '300px 0px' }).observe(marco);
    } else {
      visible = true;
    }

    if (cfg.arrastre) {
      var inicioX = 0;
      var inicioY = 0;
      var arrastrando = false;
      var horizontal = null;
      var origen = 0;

      function comenzar(x, y) {
        if (apilado || !distancia) return;
        inicioX = x;
        inicioY = y;
        horizontal = null;
        arrastrando = true;
        origen = window.pageYOffset || document.documentElement.scrollTop || 0;
      }

      function seguir(x, y, evento) {
        if (!arrastrando) return;
        var dx = x - inicioX;
        var dy = y - inicioY;
        if (horizontal === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          horizontal = Math.abs(dx) > Math.abs(dy);
        }
        if (!horizontal) return;
        if (evento && evento.cancelable) evento.preventDefault();
        var recorrible = marco.offsetHeight - altoFijo;
        var factor = distancia ? recorrible / distancia : 0;
        window.scrollTo(0, origen - dx * factor);
      }

      function terminar() {
        arrastrando = false;
        horizontal = null;
      }

      fijo.addEventListener('touchstart', function (e) { comenzar(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
      fijo.addEventListener('touchmove', function (e) { seguir(e.touches[0].clientX, e.touches[0].clientY, e); }, { passive: false });
      fijo.addEventListener('touchend', terminar);
      fijo.addEventListener('touchcancel', terminar);
      fijo.addEventListener('mousedown', function (e) { if (e.button === 0) comenzar(e.clientX, e.clientY); });
      window.addEventListener('mousemove', function (e) { if (arrastrando) seguir(e.clientX, e.clientY, e); });
      window.addEventListener('mouseup', terminar);
    }

    medir();
    window.requestAnimationFrame(ciclo);
    window.addEventListener('resize', medir);
    window.addEventListener('orientationchange', medir);
    window.addEventListener('load', medir);

    if ('ResizeObserver' in window) {
      new ResizeObserver(medir).observe(pista);
    }

    seccion.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', medir);
    });
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-recorrido]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var nodo = evento.target.querySelector('[data-recorrido]');
    if (nodo) iniciar(nodo);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-productos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(seccion) {
    if (!seccion || seccion.dataset.tesIniciado === '1') return;
    seccion.dataset.tesIniciado = '1';

    var cfg = {};
    try { cfg = JSON.parse(seccion.querySelector('[data-testimonios-config]').textContent); } catch (e) { cfg = {}; }

    var carril = seccion.querySelector('[data-tes-carril]');
    var pista = seccion.querySelector('[data-tes-pista]');
    if (!carril || !pista) return;

    function anchoPaso() {
      var tarjeta = pista.querySelector('[data-tes-tarjeta]');
      if (!tarjeta) return carril.clientWidth;
      var estilo = window.getComputedStyle(pista);
      var gap = parseFloat(estilo.columnGap || estilo.gap || '0') || 0;
      return tarjeta.getBoundingClientRect().width + gap;
    }

    var btnSig = seccion.querySelector('[data-tes-siguiente]');
    var btnAnt = seccion.querySelector('[data-tes-anterior]');
    if (btnSig) btnSig.addEventListener('click', function () { carril.scrollBy({ left: anchoPaso(), behavior: 'smooth' }); });
    if (btnAnt) btnAnt.addEventListener('click', function () { carril.scrollBy({ left: -anchoPaso(), behavior: 'smooth' }); });

    if (cfg.arrastre) {
      var abajo = false;
      var movido = false;
      var inicioX = 0;
      var inicioScroll = 0;

      carril.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        abajo = true;
        movido = false;
        inicioX = e.pageX;
        inicioScroll = carril.scrollLeft;
      });
      window.addEventListener('mousemove', function (e) {
        if (!abajo) return;
        var dx = e.pageX - inicioX;
        if (Math.abs(dx) > 5) {
          movido = true;
          carril.classList.add('testimonios-carril--arrastrando');
        }
        carril.scrollLeft = inicioScroll - dx;
      });
      window.addEventListener('mouseup', function () {
        abajo = false;
        setTimeout(function () { carril.classList.remove('testimonios-carril--arrastrando'); }, 0);
      });
      carril.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    function detenerTodos(salvo) {
      seccion.querySelectorAll('[data-tes-tarjeta]').forEach(function (tarjeta) {
        if (tarjeta === salvo) return;
        var v = tarjeta.querySelector('[data-tes-video]');
        if (v && !v.paused) v.pause();
        tarjeta.classList.remove('testimonios-tarjeta--reproduciendo');
      });
    }

    seccion.querySelectorAll('[data-tes-play]').forEach(function (boton) {
      var tarjeta = boton.closest('[data-tes-tarjeta]');
      var video = tarjeta.querySelector('[data-tes-video]');
      if (!video) return;
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        detenerTodos(tarjeta);
        video.muted = false;
        video.controls = true;
        tarjeta.classList.add('testimonios-tarjeta--reproduciendo');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
      video.addEventListener('ended', function () {
        tarjeta.classList.remove('testimonios-tarjeta--reproduciendo');
        video.controls = false;
      });
      video.addEventListener('pause', function () {
        if (video.currentTime > 0 && !video.ended) return;
      });
    });

    seccion.querySelectorAll('[data-tes-play-embed]').forEach(function (boton) {
      var tarjeta = boton.closest('[data-tes-tarjeta]');
      var contenedor = tarjeta.querySelector('[data-tes-embed]');
      if (!contenedor) return;
      boton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        detenerTodos(tarjeta);
        var url = contenedor.getAttribute('data-url');
        var union = url.indexOf('?') === -1 ? '?' : '&';
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', url + union + 'autoplay=1');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        contenedor.innerHTML = '';
        contenedor.appendChild(iframe);
        tarjeta.classList.add('testimonios-tarjeta--reproduciendo');
      });
    });

    if (cfg.autoplayVideo && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          var tarjeta = entrada.target;
          var video = tarjeta.querySelector('[data-tes-video]');
          if (!video) return;
          if (entrada.isIntersecting) {
            if (video.paused && !tarjeta.classList.contains('testimonios-tarjeta--reproduciendo')) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (!tarjeta.classList.contains('testimonios-tarjeta--reproduciendo')) {
            video.pause();
          }
        });
      }, { threshold: 0.6 });
      seccion.querySelectorAll('[data-tes-tarjeta]').forEach(function (tarjeta) {
        if (tarjeta.querySelector('[data-tes-video]')) observador.observe(tarjeta);
      });
    }
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-testimonios]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', function (evento) {
    var nodo = evento.target.querySelector('[data-testimonios]');
    if (nodo) iniciar(nodo);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
